import React from "react";
import clsx from 'clsx';
import { SvgIcon } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    width: 22,
    height: 22
  }
});

class IcYouTube extends React.Component {

  render() {
    const { classes, className } = this.props;

    return <SvgIcon className = { clsx(classes.root, className) }
                    titleAccess = 'Youtube'
                    viewBox = { "0 0 22 22" } >
      <path d="M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11Z" fill="#004876"/>
      <path d="M16.6214 8.28358C16.4865 7.7652 16.0889 7.357 15.584 7.21847C14.6691 6.96669 11 6.96669 11 6.96669C11 6.96669 7.33083 6.96669 6.41583 7.21847C5.91097 7.357 5.51337 7.7652 5.37843 8.28358C5.1333 9.22308 5.1333 11.1834 5.1333 11.1834C5.1333 11.1834 5.1333 13.1436 5.37843 14.0831C5.51337 14.6015 5.91097 15.0097 6.41583 15.1483C7.33083 15.4 11 15.4 11 15.4C11 15.4 14.6691 15.4 15.584 15.1483C16.0889 15.0097 16.4865 14.6015 16.6214 14.0831C16.8666 13.1436 16.8666 11.1834 16.8666 11.1834C16.8666 11.1834 16.8666 9.22308 16.6214 8.28358Z" fill="#1A1919"/>
      <path d="M9.89996 13.2V9.53331L12.8333 11.3667L9.89996 13.2Z" fill="#004876"/>
    </SvgIcon>
  }
}

export default withStyles(styles)(IcYouTube);
